import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";

import { MdSnackBar } from "@angular/material";

import { TdDialogService, TdLoadingService } from "@covalent/core";

import { StorageService } from "../../services/storage.service";
import { AuthenticationService } from "../../services/security/authentication.service"

import "rxjs/add/operator/toPromise";

@Component({
  selector: "container-form",
  providers: [StorageService],
  templateUrl: "./form.component.html",
  styleUrls: ["./form.component.scss"],
})
export class ContainerFormComponent implements OnInit {
  action: string;
  containerName: string;
  container: any = {};

  containerLineHaul: string;
  containerWeight: number;
  containerDepth: number;
  containerLength: number;
  containerHeight: number;
  containerRelabel: string;

  containers: string[] = [];
  filteredContainers: string[];
  lineHauls: any[] = [];
  staticRelabelsOptions: any[] = ['Yes'];

  constructor(
    private _authenticationService: AuthenticationService,
    private _storageService: StorageService,
    private _router: Router,
    private _route: ActivatedRoute,
    private _snackBarService: MdSnackBar,
    private _loadingService: TdLoadingService,
    private _dialogService: TdDialogService
  ) {}

  goBack(): void {
    this._router.navigate(["/container"]);
  }

  ngOnInit(): void {
    this.loadLineHauls();
    this._route.url.subscribe((url: any) => {
      this.action = url.length > 1 ? url[1].path : "add";
    });
    this._route.params.subscribe((params: { containerName: string }) => {
      this.containerName = params.containerName;
      if (this.containerName) {
        this.load();
      } else {
        this.containers = [];
      }
    });
  }

  filteredLineHauls(): Array<string> {
      const storageName = this._authenticationService.getStorageName();
      const countryCode = storageName.substring(0, 2);

      return this.containerLineHaul ? this.lineHauls.filter(item =>
        item.name.toLowerCase().includes(this.containerLineHaul.toLowerCase()) &&
        item.workflow.includes(countryCode)
      ) : this.lineHauls.filter(item =>
        item.workflow.includes(countryCode)
      );
  }
  
  async loadLineHauls(): Promise<void> {
    try {
      this.lineHauls = await this._storageService.getLineHauls().toPromise();
    } catch (error) {
      console.log("There was an error loading the line hauls!");
    } finally {
    }
  }

  async load(): Promise<void> {
    try {
      this._loadingService.register("container.form");
      this.container = await this._storageService
        .getContainer(this.containerName)
        .toPromise();
      this.container.addInfo.forEach((element) => {
        if (element.keyValue == "line_haul") {
          this.containerLineHaul = element.textValue;
        }
        if (element.keyValue == "weight") {
          this.containerWeight = element.numericalValue;
        }
        if (element.keyValue == "depth") {
          this.containerDepth = element.numericalValue;
        }
        if (element.keyValue == "height") {
          this.containerHeight = element.numericalValue;
        }
        if (element.keyValue == "relabel") {
          this.containerRelabel = element.textValue;
        }
        if (element.keyValue == "length") {
          this.containerLength = element.numericalValue;
        }
      });
    } catch (error) {
      this._dialogService.openAlert({
        message: "There was an error loading the container",
      });
    } finally {
      this._loadingService.resolve("container.form");
    }
  }

  async save(): Promise<void> {
    let noDots = this.container.name.split(".").join("");
    this.container.name = noDots;

    const validNamePattern = /^[a-zA-Z0-9_]*$/;
    if (!validNamePattern.test(this.container.name)) {
      this._dialogService.openAlert({
        title: "Invalid Container Name Input",
        message: "Container Name can only contain letters, numbers, and underscores.",
      });
    }

    try {
      this._loadingService.register("container.form");
      let update: boolean;
      let updateRelabel: boolean;
      if (this.action == "edit") {
        update = true;
        this.container.containerStatus = "CLOSED";
        updateRelabel = false;
      } else {
        update = false;
        this.container.containerStatus = "OPEN";
        this.container.containerType = "CONTAINER";
      }
      // store only not null properties
      this.container.addInfo = [];
      if (this.containerLineHaul) {
        let item: any = {};
        item.keyValue = "line_haul";
        item.textValue = this.containerLineHaul;
        this.container.addInfo.push(item);
      }
      if (this.containerWeight) {
        let item: any = {};
        item.keyValue = "weight";
        item.numericalValue = this.containerWeight;
        this.container.addInfo.push(item);
      }
      if (this.containerDepth) {
        let item: any = {};
        item.keyValue = "depth";
        item.numericalValue = this.containerDepth;
        this.container.addInfo.push(item);
      }
      if (this.containerLength) {
        let item: any = {};
        item.keyValue = "length";
        item.numericalValue = this.containerLength;
        this.container.addInfo.push(item);
      }
      if (this.containerHeight) {
        let item: any = {};
        item.keyValue = "height";
        item.numericalValue = this.containerHeight;
        this.container.addInfo.push(item);
      }
      if (this.containerRelabel) {
        let item: any = {};
        item.keyValue = "relabel";
        item.textValue = this.containerRelabel;
        this.container.addInfo.push(item);
      }
      await this._storageService
        .updateContainer(this.container, update)
        .toPromise();
      this._snackBarService.open("Container saved", "Ok");
      this.goBack();
    } catch (error) {
      this._dialogService.openAlert({
        title: "There was an error saving the container",
        message: error.message,
      });
    } finally {
      this._loadingService.resolve("container.form");
    }
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/_storageApp.Front.release/src/app/container/form/form.component.ts